(function () {
  var root = document.documentElement;
  var body = document.body;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var INVERT_STORAGE_KEY = 'npa-invert-mode';

  root.classList.remove('no-js');

  function setInvertMode(enabled) {
    root.setAttribute('data-invert-mode', enabled ? 'true' : 'false');

    var toggles = document.querySelectorAll('.invert-toggle');
    toggles.forEach(function (button) {
      button.setAttribute('aria-pressed', enabled ? 'true' : 'false');
      button.textContent = enabled ? 'Normal UI' : 'Invert UI';
    });
  }

  function initInvertMode() {
    var persisted = null;

    try {
      persisted = window.localStorage.getItem(INVERT_STORAGE_KEY);
    } catch (error) {
      persisted = null;
    }

    setInvertMode(persisted === 'true');

    document.querySelectorAll('.invert-toggle').forEach(function (button) {
      button.addEventListener('click', function () {
        var isEnabled = root.getAttribute('data-invert-mode') === 'true';
        var nextState = !isEnabled;

        setInvertMode(nextState);

        try {
          window.localStorage.setItem(INVERT_STORAGE_KEY, String(nextState));
        } catch (error) {
          /* localStorage can fail in restricted browsing modes */
        }
      });
    });
  }

  function initAnnouncementRotation() {
    if (reduceMotion) {
      return;
    }

    var wrappers = document.querySelectorAll('[data-announcement-rotate="true"]');

    wrappers.forEach(function (wrapper) {
      var items = wrapper.querySelectorAll('.announcement-bar__message');
      if (items.length < 2) {
        return;
      }

      var index = 0;
      window.setInterval(function () {
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }, 4000);
    });
  }

  function initBetaQueryFlag() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('beta') === '1') {
      body.classList.add('beta-reveal');
    }
  }

  function initRandomGlitch() {
    if (reduceMotion) {
      return;
    }

    if (body.dataset.randomGlitch !== 'true') {
      return;
    }

    var targets = Array.prototype.slice.call(document.querySelectorAll('[data-glitch]'));
    if (targets.length === 0) {
      return;
    }

    function pulse() {
      var target = targets[Math.floor(Math.random() * targets.length)];
      target.classList.add('is-glitching');
      window.setTimeout(function () {
        target.classList.remove('is-glitching');
      }, 250);
    }

    window.setInterval(pulse, 4200);
  }


  function initModals() {
    var openers = document.querySelectorAll('[data-modal-open]');
    if (openers.length === 0) {
      return;
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.setAttribute('hidden', 'hidden');
      document.body.classList.remove('modal-open');
    }

    function openModal(modal) {
      if (!modal) return;
      modal.removeAttribute('hidden');
      document.body.classList.add('modal-open');
    }

    openers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var modalId = trigger.getAttribute('data-modal-open');
        var modal = document.querySelector('[data-modal="' + modalId + '"]');
        openModal(modal);
      });
    });

    document.querySelectorAll('[data-modal-close]').forEach(function (closer) {
      closer.addEventListener('click', function () {
        closeModal(closer.closest('[data-modal]'));
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var visible = document.querySelector('[data-modal]:not([hidden])');
      closeModal(visible);
    });
  }

  function initStickyATCVisibility() {
    var sticky = document.querySelector('[data-sticky-atc]');
    if (!sticky) {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      return;
    }

    var form = document.querySelector('.product-form');
    if (!form || reduceMotion) {
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            sticky.style.opacity = '0';
            sticky.style.pointerEvents = 'none';
          } else {
            sticky.style.opacity = '1';
            sticky.style.pointerEvents = 'auto';
          }
        });
      },
      { threshold: 0.15 }
    );

    observer.observe(form);
  }

  initInvertMode();
  initAnnouncementRotation();
  initBetaQueryFlag();
  initRandomGlitch();
  initStickyATCVisibility();
  initModals();
})();
